export default "<div class=\"callMessageStyle\">\r\n  <p class=\"callMessageTxtStyle\">\r\n    {{ message }}\r\n  </p>\r\n</div>\r\n";